import SexAgeFbStatistics from './SexAgeFbStatistics';

export default SexAgeFbStatistics;
